import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  max-height: ${props => (props.withCall ? 100 : 180)}px;
`;
export const Row = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  border-bottom: 1px solid ${colors.lightGray06};
  cursor: pointer;
  width: 100%;
  min-height: 46px;
  max-height: 46px;
`;
export const Left = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .avatar {
    width: 23px;
    height: 23px;
    font-size: 10px;
    margin-right: 5px;
  }

  span {
    font-size: 13px;
    color: ${colors.black};
  }
`;
export const Right = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .two-lines {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }

  span {
    font-size: 13px;
    color: ${colors.black};

    .highlight {
      background-color: transparent!important;
      color: ${colors.lightBlue};
    }
  }
`;
